import React from 'react';
import { ExtraWrapper } from './styled';

function SectionExtra({ text }) {
  return (
    <ExtraWrapper>
      {text}
    </ExtraWrapper>
  );
}

export default SectionExtra;
